module.exports = __webpack_public_path__ + "img/test-qr.18982980.svg";